module.exports = __webpack_public_path__ + "img/vegard.0ebfb8c0.jpg";